<div class="image-container" [ngStyle]="{'background-image': 'url(' + (paseo?.foto_cabecera_grande || defaultImage) + ')'}">
  <div class="grupo-iconos">
    <div class="delete-icon" (click)="quitarFoto()" *ngIf="(imageUrl || paseo?.foto_cabecera_grande)">
      <i class="fa-regular fa-trash-can fs-3"></i>
    </div>
    <div class="upload-icon" (click)="fileInput.click()">
      <i class="fa-regular fa-camera fs-3"></i>
    </div>
  </div>
  <input 
    type="file" 
    #fileInput 
    accept="image/*" 
    (change)="onFileSelected($event)" 
    hidden
  />
</div>
<div class="row mb-3">
  <div class="col-12 col-sm-12 col-md">
    <div class="mb-1">
      <label for="pa_titulo" class="form-label">Titulo</label>
      <input type="text" id="pa_titulo" name="pa_titulo" class="form-control" [(ngModel)]="paseo.pa_titulo">
    </div>
    <div class="mb-1">
      <label for="pa_descripcion" class="form-label">Descripción</label>
      <textarea autoResize [maxLines]="5" [maxChars]="500" id="pa_descripcion" class="form-control" rows="3" [(ngModel)]="paseo.pa_descripcion"></textarea>
    </div>
  </div>
  <div class="col">
    <div class="row">
      <div class="col mb-1">
        <label for="pa_fecha" class="form-label">Fecha</label>
        <input type="date" id="pa_fecha" name="pa_fecha" class="form-control" [(ngModel)]="paseo.pa_fecha">
      </div>
      <div class="col mb-1">
        <label for="pa_hora" class="form-label">Hora</label>
        <input type="time" id="pa_hora" name="pa_hora" class="form-control" [(ngModel)]="paseo.pa_hora">
      </div>
    </div>
    <div class="mb-1">
      <label for="pa_ubicacion" class="form-label">Ubicación</label>
      <input type="text" id="pa_ubicacion" name="pa_ubicacion" class="form-control" [maxChars]="150" [(ngModel)]="paseo.pa_ubicacion">
    </div>
  </div>
</div>
<div class="mb-2 fw-bold">¿Con quien vas de paseo?</div>
<div class="row">
  <div class="col-12 col-sm-12 col-md-auto mb-3" *ngFor="let mascota of paseosComp.mascotas">
    <div class="border rounded p-2 pointer" (click)="seleccionarMascota(mascota)" [ngClass]="{'bg-iguau text-white': mascota.checked}">
      <div class="row">
        <div class="col-auto">
          <img
            *ngIf="mascota.foto.foto_thumb"
            [src]="mascota.foto.foto_thumb"
            class="rounded-circle pointer"
            width="50px"
            alt="Foto de perfil"
            />
        </div>
        <div class="col-auto">
          <div>{{mascota.ma_nombre | firstWord}}</div>
          <div class="text-secondary" [ngClass]="{'text-white': mascota.checked}">
            <div>
              <span *ngIf="mascota.ma_raza && mascota.ma_edad" title="Raza y edad">{{mascota.ma_raza}} de {{mascota.ma_edad}}</span>
              <span *ngIf="!mascota.ma_raza && mascota.ma_edad">{{mascota.ma_edad}}</span>
              <span *ngIf="mascota.ma_tipo" title="Tipo">, {{mascota.ma_tipo}}</span>
            </div>
            <span *ngIf="mascota.ma_sexo=='Macho'" title="Sexo"><i class="fa-solid fa-mars"></i></span>
            <span *ngIf="mascota.ma_sexo=='Hembra'" title="Sexo"><i class="fa-solid fa-venus"></i></span>
            <span *ngIf="mascota.ma_sexo=='Hembra' || mascota.ma_sexo=='Macho'" title="Sexo">{{mascota.ma_sexo}}</span>
            <span *ngIf="mascota.ma_tamano" class="ms-2 badge text-bg-info" title="Tamaño">{{mascota.ma_tamano}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="w-100" *ngIf="!paseosComp.mascotas || !(paseosComp.mascotas | keyvalue)?.length">
  <div class="spinner-grow spinner-grow-sm text-iguau" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>          
</div>
<div class="alert alert-danger" role="alert" *ngIf="error != ''">
  {{error}}
</div>
<div class="mt-3 d-flex w-100 justify-content-end">
  <div class="row">
    <div class="col mb-3" *ngIf="paseo.pa_id != 0">
      <button class="btn btn-primary" type="button" (click)="borrarPaseo()">Borrar</button>
    </div>
    <div class="col-auto mb-3">
      <button class="btn btn-secondary" type="button" (click)="cancelar()">Cancelar</button>
    </div>
    <div class="col-auto mb-3">
      <button class="btn btn-primary" type="button" (click)="publicarPaseo()">Publicar</button>
    </div>
  </div>
</div>
